import styled from 'styled-components';

interface RadioButtonSelectProps {
  value: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
}
export const RadioButtonSelect = (props: RadioButtonSelectProps) => {
  const { value, options, onChange } = props;

  return (
    <RadioButtonGroup>
      {options.map((option) => (
        <RadioButtonItem
          key={option.value}
          onClick={() => onChange(option.value)}
          active={value === option.value}
        >
          {option.label}
        </RadioButtonItem>
      ))}
    </RadioButtonGroup>
  );
};

const RadioButtonGroup = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  margin-bottom: 8px;
`;

const RadioButtonItem = styled.button<{ active?: boolean }>`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border: none;
  color: #2c384a;
  font-size: 1rem;
  background-color: white;
  border: 1px solid #eeeeee;

  &:first-of-type {
    border-radius: 4px 0 0 4px;
  }
  &:last-of-type {
    border-radius: 0 4px 4px 0;
  }
  &:not(:first-of-type) {
    margin-left: -1px;
  }

  ${({ active }) => {
    if (!active) return '';
    return `
      z-index: 1;
      border-color: var(--color-primary-400);
    `;
  }}
`;
